<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption.filter(obj => { return (obj.key == lang) })[0].value }} </span>
      </CCardHeader>
      <CCardBody>

        <div v-for="objs in item" >
          <CRow>
            <CCol @click="toggleDetails(objs)">
              <label class="font-weight-bold" >
                <CIcon name="cil-layers" class="mr-3"/>  {{objs.title.filter(obj => { return (obj.key == lang) })[0].value}}
              </label>
              <div v-html="objs.description.filter(obj => { return (obj.key == lang) })[0].value"/>
            </CCol>
            <CCol col="1">
              {{ onLevelCheck(objs.levels) }}
            </CCol>
          </CRow>
          <CDropdownDivider/>
          <CCollapse :show="Boolean(objs._toggled)" :duration="collapseDuration">
            <CRow v-for="(objsLevel, index) in objs.levels">
              <CCol>
                <CCard class="bg-style2 mb-3">
                  <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
                    <span class="font-weight-bold h6"> <CIcon name="cil-layers"/>  {{objsLevel.title.filter(obj => { return (obj.key == lang) })[0].value }} </span>
                    <span class="font-weight-bold float-right"> {{ objsLevel.item.reduce(function (sum, objs) { return (objs.checked == true)? sum =sum+1:sum =sum;  }, 0) }}/{{objsLevel.item.length}}</span>
                  </CCardHeader>
                  <CCardBody class="p-3" >
                    <CCol col="12">
                      <CRow  v-for="obj in objsLevel.item">

                        <div v-for="ob in obj.checkeds"  v-if="type == 1" >
                          <CInputCheckbox
                              type="checkbox"
                              :checked="Boolean(ob)"
                              disabled
                          />
                        </div>
                        <CCol v-if="type == 1" >
                          <CInputCheckbox
                              type="checkbox"
                              :label="obj.title.filter(obj => { return (obj.key == lang) })[0].value"
                              :id="obj._id"
                              :name="obj._id"
                              v-model="obj.checked"
                              :checked="obj.checked"
                              @input="obj.checked = $event.target.checked"
                          />
                        </CCol>

                        <div v-for="ob in obj.checkeds"  v-if="type == 0 && obj.checkeds !== undefined" >
                          <CInputCheckbox
                              type="checkbox"
                              :checked="Boolean(ob)"

                          />
                        </div>
                        <CCol col="11" v-if="type == 0 && obj.checkeds !== undefined" class="float-left">{{obj.title.filter(obj => { return (obj.key == lang) })[0].value}}</CCol>
                        <CCol v-if="type == 0 && obj.checkeds === undefined" >
                          <CInputCheckbox
                              type="checkbox"
                              :label="obj.title.filter(obj => { return (obj.key == lang) })[0].value"
                              :id="obj._id"
                              :name="obj._id"
                              v-model="obj.checked"
                              :checked="obj.checked"
                              @input="obj.checked = $event.target.checked"
                          />
                        </CCol>
                      </CRow>
                    </CCol>

                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
            <CRow class="mb-2">
              <CCol>
                <QEditor :objs="objs"/>
              </CCol>
            </CRow>
          </CCollapse>
        </div>

      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import QEditor from "@/projects/views/E-Performances/Estimate/components/QEditor";

export default {
  name: 'Cometencys',
  components: {QEditor},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },

    caption: {
      type: Array,
      default() {
        return []
      }
    },
    type: {
      type: Number,
      default: 0
    },
    level: {
      type: Number,
      default: 1
    },

    item: {
      type: Array,
      default() {
        return []
      }
    }



  },

  data: function () {
    return {
      collapseDuration: 0

    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {


      if(this.$route.query.level != null){
        // จะใช้เมื่อ status panding
        var objs = this.item;
        for(var i=0; i<objs.length; i++){
          var objsLevel = objs[i].levels
          for(var j=0; j<this.$route.query.level; j++ ){
            var objItem = objsLevel[j].item
            for(var k=0; k<objItem.length; k++){
              objItem[k].checked = true;
            }
          }
        }
      }


    },

    onLoad() {
    },

    onSubmit(parent,index){
    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    onLevelCheck(objs){
      var isCheck = 0;
      var isTotal = 0;

      objs.filter(item => {
        isTotal = isTotal+item.item.length
        isCheck = isCheck+item.item.filter(ob => { return (ob.checked == true) }).length
      })

      return isCheck+'/'+isTotal;
    }



  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
